/* eslint-disable eol-last */
// java 涂工接口
import request from '@/utils/request'
// 汇总报表   生产报表 begin
export function workorderSum(query) {
  return request({
    url: '/api/out/report/workorder/workorderSum',
    method: 'get',
    params: query
  })
}
// 日生产报表
export function workorder(query) {
  return request({
    url: '/api/out/report/workorder/workorder',
    method: 'get',
    params: query
  })
}
// 日排产报表
export function productionworkorder(query) {
  return request({
    url: '/api/report/mt/api/workorder/productionworkorder',
    method: 'get',
    params: query
  })
}
// 排产报表修改
export function insertorupdate(data) {
  return request({
    url: '/api/report/mt/api/workorder/insertorupdate',
    method: 'post',
    data
  })
}
// 排产报表列删除
export function deleteproductionrate(data) {
  return request({
    url: '/api/report/mt/api/workorder/deleteproductionrate',
    method: 'post',
    data
  })
}
// 订单统计报表   生产报表end
export function orderno(query) {
  return request({
    url: '/api/out/report/workorder/orderno',
    method: 'get',
    params: query
  })
}
// 追溯码发放查询   物流报表begin
export function codefind(query) {
  return request({
    url: '/api/report/mt/api/qrcodeorder/find',
    method: 'get',
    params: query
  })
}
// 追溯码人工申请表
export function findArtificial(query) {
  return request({
    url: '/api/report/mt/api/qrcodeorder/findArtificial',
    method: 'get',
    params: query
  })
}
// 菲尼克斯退货
export function findRejected(query) {
  return request({
    url: '/api/out/report/rejectedlog/findRejected',
    method: 'get',
    params: query
  })
}
// 市场监察报表
export function check(query) {
  return request({
    url: '/api/out/report/check/check',
    method: 'get',
    params: query
  })
}
// 仓库发货端报表
export function orderandworkproducts(query) {
  return request({
    url: '/api/out/report/order/orderandworkproducts',
    method: 'get',
    params: query
  })
}
// 成品交接单
export function producehandover(query) {
  return request({
    url: '/api/out/report/workorder/producehandover',
    method: 'get',
    params: query
  })
}
// 首页图表接口
// 扫码次数
export function scancount(data) {
  return request({
    url: '/api/out/report/index/scancount',
    method: 'post',
    data
  })
}
// 窜货区域
export function insepctmap(data) {
  return request({
    url: '/api/out/report/index/insepctmap',
    method: 'post',
    data
  })
}
export function insepctmapcity(data) {
  return request({
    url: '/api/out/report/index/insepctmapcity',
    method: 'post',
    data
  })
}
// 生产数量
export function productioncount(data) {
  return request({
    url: '/api/out/report/index/productioncount',
    method: 'post',
    data
  })
}
// 退货数量
export function returncount(data) {
  return request({
    url: '/api/out/report/index/returncount',
    method: 'post',
    data
  })
}
// 发货数量
export function sendcount(data) {
  return request({
    url: '/api/out/report/index/sendcount',
    method: 'post',
    data
  })
}
// 供应商生码数量
export function suppsendqrcode(data) {
  return request({
    url: '/api/out/report/index/suppsendqrcode',
    method: 'post',
    data
  })
}
// 稽查窜货查省
export function inspectfleeingmap(data) {
  return request({
    url: '/api/out/report/index/inspectfleeingmap',
    method: 'post',
    data
  })
}
// 稽查窜货查市
export function inspectfleeingmapcity(data) {
  return request({
    url: '/api/out/report/index/inspectfleeingmapcity',
    method: 'post',
    data
  })
}
// 稽查扫码查省
export function inspectscanmap(data) {
  return request({
    url: '/api/out/report/index/inspectscanmap',
    method: 'post',
    data
  })
}
// 稽查扫码查市
export function inspectscanmapcity(data) {
  return request({
    url: '/api/out/report/index/inspectscanmapcity',
    method: 'post',
    data
  })
}